import {NgModule} from '@angular/core';
import {Routes, RouterModule, ExtraOptions, PreloadAllModules} from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';
import {NotFoundComponent} from './pages/not-found/not-found.component';
import {PermissionDeniedComponent} from './pages/permission-denied/permission-denied.component';

const isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
const routerConfig: ExtraOptions = {
  scrollPositionRestoration: 'top',
  preloadingStrategy: PreloadAllModules,
  relativeLinkResolution: 'legacy',
  // Don't perform initial navigation in iframes
  initialNavigation: !isIframe ? 'enabled' : 'disabled',
  enableTracing: false // Set to true if you need to debug the router,
};

const routes: Routes = [
  {
    path: 'pages',
    canActivate: [MsalGuard],
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule)
  },
  {
    path: '',
    redirectTo: '/pages/applications/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'epnp',
    redirectTo: '/pages/component-reliability/component-health/lookup/cpn',
    pathMatch: 'full'
  },
  {
    path: 'academy',
    redirectTo: '/pages/documentation/academy/courses',
    pathMatch: 'full'
  },
  {
    path: 'authenticated',
    redirectTo: '/pages/applications/dashboard',
    pathMatch: 'full'
  },
  {path: '404', component: NotFoundComponent},
  {path: '403', component: PermissionDeniedComponent},
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, routerConfig)
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
